import React from 'react';
import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';
import IconSvg from '@/components/common/IconSvg';
import { HeaderRowSchema } from './HeaderRow.styles';

export const RunnerDetails: CSSObject = {
  color: 'white',
  fontWeight: 'extrabold',
};
export const RunnerDescription: CSSObject = {
  color: 'gamma.300',
  fontSize: 'xs',
  fontWeight: 'bold',
  'span:nth-child(2)': {
    color: 'rgba(255, 255, 255, 0.24)',
  },
};
export const BetOdds: CSSObject = {
  color: 'white',
};
export const TextBarrierNumber: CSSObject = {
  color: 'white',
  fontSize: '2xs',
  fontWeight: 'medium',
};
export const BetReturn = (status: TBetReturn): CSSObject => ({
  label: status,
  bg: () => {
    switch (status) {
      case 'won':
        return 'beta.200';
      case 'pending':
        return 'orange.400';
      default:
        return 'delta.300';
    }
  },
  color: () => {
    switch (status) {
      case 'won':
        return 'blackAlpha.700';
      case 'pending':
        return 'orange.800';
      default:
        return 'delta.900';
    }
  },
  boxShadow:
    '0px 2px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.25) inset',
  py: '0',
});
export const HeaderSvg: CSSObject = {
  filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
  boxSize: '5',
};
export const BetMultiIcon: CSSObject = {
  boxSize: '5',
};
export const MultiIcon = () => (
  <IconSvg
    name="multi_betslip"
    className="svgIcon"
    color="beta .300"
    boxSize="5"
    mb="1.5"
  />
);
export const TextDescription: CSSObject = {
  textTransform: 'capitalize',
};
export const headerRowStyles: HeaderRowSchema = {
  originalOdds: {
    color: 'gray.100',
  },
  headerRowSvg: {
    fill: 'alpha.500',
    color: 'beta.300',
  },
};
